/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   ShortTerm HeaderText
 */

import { Flex, Heading, Text, useColorModeValue } from '@chakra-ui/react'
import React from 'react'
import {
  HEADER_TEXT,
  HEADER_TEXT_ZUMPER_RENTALS,
  SUBHEADER_TEXT,
  SUBHEADER_TEXT_ZUMPER_RENTALS,
} from '../../constants'

export interface Props {
  isZumperRentals: boolean
}

export const HeaderText = ({ isZumperRentals }: Props) => {
  const subText = useColorModeValue('gray.600', 'gray.300')
  return (
    <Flex flexDir="column" gap={4} alignItems="center" marginTop="116px" marginBottom={8}>
      <Heading
        fontSize={60}
        lineHeight="56px"
        letterSpacing="-0.72px"
        width={isZumperRentals ? '475px' : '600px'}
        textAlign="center"
      >
        {isZumperRentals ? HEADER_TEXT_ZUMPER_RENTALS : HEADER_TEXT}
      </Heading>
      <Text
        as="h1"
        variant="body24Reg"
        lineHeight={8}
        letterSpacing="-0.5px"
        color={subText}
        textAlign="center"
        maxW="386px"
      >
        {isZumperRentals ? SUBHEADER_TEXT_ZUMPER_RENTALS : SUBHEADER_TEXT}
      </Text>
    </Flex>
  )
}
